import { useEffect, useState } from "react";
import { faHeart, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

import { UseCartList } from "../../services/cart/cart.context";


export const CartListContainer = () => {

    const navigateTo = useNavigate();

    const { toggleCart } = UseCartList();

    const { wishList, cart } = UseCartList();

    const [listLength, setListLength] = useState(wishList?.length);
    const [cartLength, setCarLength] = useState(cart?.length);

    useEffect(() => {
        setListLength(wishList?.length);
        setCarLength(cart?.length);
    },[wishList?.length, cart?.length])

    return (
        <div className="cart-list-container">
            <button 
                className="cart-list-button" 
                onClick={() => navigateTo("/wishlist")}
            >
                <FontAwesomeIcon icon={faHeart} className="cart-list-icon" />
                <span className="liked-num">{listLength}</span>
            </button>
            <button 
                className="cart-list-button"
                onClick={() => toggleCart()}
            >
                <FontAwesomeIcon icon={faShoppingCart} className="cart-list-icon" />
                <span className="liked-num">{cartLength}</span>
            </button>
        </div>
    )
}